import React from "react";
import { auth } from "../../firebase-config";

import styles from "./Login.module.css";
import Input from "../../Components/forms/Input";
import { UserContext } from "../../UserContext";
import Button from "../../Components/forms/Button";
import useForm from "../../Hooks/useForm";
import TipInput from "../../Components/forms/TipInput";
import ReCAPTCHA from "react-google-recaptcha";
import ForgotPassword from "../../Components/ForgotPassword/ForgotPassword"

const Login = () => {
  React.useEffect(() => {
    if (window.location.href.includes("localhost")) {
      setBtLogin(true);
      setRecaptchaLocalhost(false);
    }
  }, []);

  const userEmail = useForm("email");
  const userPassword = useForm();

  const [btLogin, setBtLogin] = React.useState(false);
  const [recaptchaLocalhost, setRecaptchaLocalhost] = React.useState(true);

  const [forgotPassword, setForgotPassword] = React.useState(false)

  const { userLogin, userLogout, data, error, loading } =
    React.useContext(UserContext);

    function handleCloseDialog() {
      setForgotPassword(false)
    }
    function openForgotPassword() {
      setForgotPassword(true)
    }
  


  function handleLogin(event) {
    event.preventDefault();
    userLogin(auth, userEmail.value, userPassword.value, onChange);
  }
  function handleLogout(event) {
    event.preventDefault();
    userLogout(auth);
  }
  function onChange(value) {
    setBtLogin(true);
  }
  return (
    <div className={styles.login}>
      <div className={styles.boxLogin}>
        {!data ? (
          <>
            <form className={styles.formsLogin} onSubmit={handleLogin}>
              <h1 className={styles.formsTitle}>Login</h1>
              {error && (
                <p className={styles.errorLogin}>Usuário/Senha inválidos.</p>
              )}
              <Input
                placeholder="E-mail"
                type="text"
                className={styles.formsInput}
                {...userEmail} />
              <TipInput>E-mail</TipInput>
              <Input
                placeholder="Senha"
                label="Senha"
                autoComplete="on"
                type="password"
                className={styles.formsInput}
                {...userPassword} />
              <TipInput>Senha</TipInput>

              {btLogin == false ? (
                <Button disabled className={styles.formsbtn}>
                  Entrar
                </Button>
              ) : (
                <Button className={styles.formsbtn}>Entrar</Button>
              )}

              {recaptchaLocalhost == true && (
                <ReCAPTCHA
                  className={styles.recaptcha}
                  sitekey="6Leb2D8gAAAAAEJMjky_jDFPwgRbD3t56GpmthUy"
                  onChange={onChange} />
              )}
            </form>
            <div className={styles.forgotPassword}>
              <a onClick={openForgotPassword}>
                <span>Esqueci minha senha</span>
              </a>
            </div>
          </>
        ) : (
          <div>
            <h2 className={styles.formsTitleLogeded}>
              Você está logado com o email:
            </h2>
            <p className={`${styles.emailPageLogin} emailIsLogeded`}>
              {data?.email}
            </p>
            <Button className={styles.formsbtn} onClick={handleLogout}>
              Sair
            </Button>
          </div>
        )}
      </div>
      <ForgotPassword
        isOpen={forgotPassword}
        onRequestClose={handleCloseDialog}
        
      />
    </div>
  );
};

export default Login;
